export const Breakpoints = {
    xs: 0,
    sm: 320,
    md: 600,
    lg: 960,
    xl: 1280
};

export const NAV_BREAK_DESKTOP = 850;
